module.exports = __webpack_public_path__ + "static/media/rochdale_council_logo.193f3406.png";